var map = {
	"./01-wellenfoermige-bewegung.svg": 91536,
	"./02-vertikale-kreisbewegung.svg": 93477,
	"./03-kurze-bewegung-mit-abrupten-halt.svg": 95146,
	"./04-horizontale-kreisbewegung-bei-vertikaler-handhaltung.svg": 13294,
	"./05-gerade-bewegung.svg": 24381,
	"./06-wiederholte-hin-und-her-bewegung.svg": 4751,
	"./07-bogenbewegung.svg": 79679,
	"./08-zickzack-bewegung.svg": 31380,
	"./09-kreisende-bewegung.svg": 95829,
	"./10-drehende-bewegung-im-handgelenk.svg": 93928,
	"./11-bewegung-mit-sich-oeffnender-hand.svg": 9260,
	"./12-bewegung-mit-sich-schließender-hand.svg": 30795,
	"./13-kopfschuettelnde-bewegung.svg": 4705,
	"./14-kopfnickende-bewegung.svg": 75699,
	"./15-bewegung-mit-beruehrung.svg": 63340,
	"./16-bewegung-mit-abruptem-halt.svg": 85790,
	"./17-fingerspiel-wie-klavier.svg": 41479,
	"./18-horizontale-kreisbewegung-bei-horizontaler-handhaltung.svg": 55977,
	"./19-bewegung-mit-drehbewegung-des-handgelenks.svg": 87760,
	"./20-einfache-hin-und-her-bewegung.svg": 18463,
	"./21-zickzack-bewegung-mit-flachhand.svg": 87100,
	"./22-ausfuehrung-mit-beruehrung.svg": 23938,
	"./23-bogenbewegung-mit-drehung-des-handgelenks.svg": 79159,
	"./24-1x-drehende-bewegung-des-handgelenks.svg": 98158,
	"./25-reiben-der-finger.svg": 90345,
	"./26-rechtwinklige-bewegung.svg": 67848,
	"./27-gleichzeitige-bewegung-mehrerer-finger-im-mittleren-und-oberen-fingergelenk.svg": 70230,
	"./28-leicht-wellenfoermige-bewegung.svg": 58264,
	"./29-lange-bewegung.svg": 91716,
	"./30-kurze-bewegung.svg": 1312,
	"./31-einfache-kreisbewegung.svg": 49568,
	"./32-bewegung-mit–drehbewegung-handgelenk.svg": 18206,
	"./33-bewegung-mit-oeffnenden-fingern.svg": 95918,
	"./34-zweimalige-bewegung-mittleres-fingergelenk.svg": 61508,
	"./35-reiben-finger-und-daumen.svg": 409,
	"./36-huepfende-bewegung.svg": 9407,
	"./37-bewegung-mit-wiederholung.svg": 57688,
	"./38-schnelle-bewegung.svg": 85588,
	"./39-rechtwinklige-bewegung.svg": 46072,
	"./40-langsame-bewegung.svg": 67960,
	"./41-bewegung-mittleres-fingergelenk.svg": 71501,
	"./42-fingerspiel-und-bewegung.svg": 41883,
	"./43-mondfoermige-bewegung-finger.svg": 58649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34152;